
export class ViewEnroll {
    enrollmentId: number;
    createdBy: string;
    uniqueId: string;
    sponsorName: string;
    sponsorNickName: string;
    parishName: string;
    contribution: number;
    netContribution: number;
    renewed: string;
    paymentDate: string;
    effectiveDate: string;
    updatedDate: string;
    createdDate: string;
}
